import React from 'react';
export default {
    // TODO: this is hacky, find better solution
    br: React.createElement("br", null),
    nbsp: React.createElement(React.Fragment, null, "\u00A0"),
    // Default rich tags
    strong: (chunks) => React.createElement("strong", null, chunks),
    span: (chunks) => React.createElement("span", null, chunks),
};
